export let setHeaderLoaded: () => void;
export const headerLoaded = new Promise<void>(resolve => (setHeaderLoaded = resolve));
